export default __webpack_public_path__ + "static/media/Chhattisgarhi_bm_2.0bd4830f.mp3";